// extracted by mini-css-extract-plugin
export var sliderRange = "_n9-2";
export var sliderRoot = "_n9-0";
export var sliderThumb = "_n9-3";
export var sliderTrack = "_n9-1";